// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__1GeDB","spinner-default":"Spinner_spinner-default__RmqEa","spinner-small":"Spinner_spinner-small__1vJy2"};